import {IAction} from 'redux/interface';
import {IAvatar, ISiteSettings, IUser, IVideoAvatar} from './interfaces';
import {InferActionsTypes} from 'redux/helpers';
import {SystemLanguage} from 'utils/constants/constants';
import {IUserProfile, IUserGroup} from '@wholesalechange/chatcomponent';

export const SET_USER = 'SET_USER';
export const ERROR_LOGIN_SET = 'ERROR_LOGIN_SET';
export const ERROR_LOGIN_CLEAR = 'ERROR_LOGIN_CLEAR';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_BOT_AVATARS = 'SET_BOT_AVATARS';
export const SET_VIDEO_AVATARS = 'SET_VIDEO_AVATARS';
export const SET_USER_AVATARS = 'SET_USER_AVATARS';
export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR';
export const UPDATE_BOT_AVATAR = 'UPDATE_BOT_AVATAR';
export const UPDATE_VIDEO_AVATAR = 'UPDATE_VIDEO_AVATAR';
export const FINISH_AUTHORIZATION = 'FINISH_AUTHORIZATION';
export const SET_SITE_SETTINGS = 'SET_SITE_SETTINGS';
export const SET_EMAIL_NOT_VERIFIED = 'SET_EMAIL_NOT_VERIFIED';
export const SET_VERIFICATION_EMAIL = 'SET_VERIFICATION_EMAIL';
export const SET_VERIFICATION_EMAIL_SENT = 'SET_VERIFICATION_EMAIL_SENT';

export const loginErrorActionSet = (): IAction<boolean> => ({
  type: ERROR_LOGIN_SET,
  payload: true
});

export const loginErrorActionClear = (): IAction<boolean> => ({
  type: ERROR_LOGIN_CLEAR,
  payload: false
});

export const setUserAction = (user: IUser): IAction<IUser> => ({
  type: SET_USER,
  payload: user
});

export const setUserProfileAction = (userProfile: IUserProfile): IAction<IUserProfile> => ({
  type: SET_USER_DATA,
  payload: userProfile
});

export const setBotAvatarsAction = (botAvatars: IAvatar[]): IAction<IAvatar[]> => ({
  type: SET_BOT_AVATARS,
  payload: botAvatars
});

export const setVideoAvatarsAction = (videoAvatars: IVideoAvatar[]): IAction<IVideoAvatar[]> => ({
  type: SET_VIDEO_AVATARS,
  payload: videoAvatars
});

export const setUserAvatarsAction = (userAvatars: IAvatar[]): IAction<IAvatar[]> => ({
  type: SET_USER_AVATARS,
  payload: userAvatars
});

export const setUserLanguageAction = (data: IUserProfile): IAction<IUserProfile> => ({
  type: SET_USER_DATA,
  payload: {
    ...data,
    language: data.language || SystemLanguage.English
  }
});

export const setUserNicknameAction = (data: IUserProfile): IAction<IUserProfile> => ({
  type: SET_USER_DATA,
  payload: {
    ...data,
    nickname: data.nickname
  }
});

export const clearUserAction = (): IAction<null> => ({
  type: SET_USER,
  payload: null
});

export const updateUserAvatarAction = (avatar: IAvatar): IAction<IAvatar> => ({
  type: UPDATE_USER_AVATAR,
  payload: avatar
});

export const updateBotAvatarAction = (avatar: IAvatar): IAction<IAvatar> => ({
  type: UPDATE_BOT_AVATAR,
  payload: avatar
});

export const updateVideoAvatarAction = (avatar: IVideoAvatar): IAction<IVideoAvatar> => ({
  type: UPDATE_VIDEO_AVATAR,
  payload: avatar
});

export const finishAuthorizationAction = (): IAction<null> => ({
  type: FINISH_AUTHORIZATION,
  payload: null
});

export const SET_USER_GROUPS = 'SET_USER_GROUPS';
export const setUserGroupsAction = (groups: IUserGroup[]): IAction<IUserGroup[]> => ({
  type: SET_USER_GROUPS,
  payload: groups
});

export const setSiteSettingsAction = (settings: ISiteSettings): IAction<ISiteSettings> => ({
  type: SET_SITE_SETTINGS,
  payload: settings
});

export const emailNotVerifiedAction = (): IAction<null> => ({
  type: SET_EMAIL_NOT_VERIFIED,
  payload: null
});

export const setVerificationEmailSentAction = (): IAction<null> => ({
  type: SET_VERIFICATION_EMAIL_SENT,
  payload: null
});

export const setVerificationEmailAction = (email: string): IAction<string> => ({
  type: SET_VERIFICATION_EMAIL,
  payload: email
});

const authActions = {
  loginErrorActionSet,
  loginErrorActionClear,
  setUserAction,
  clearUserAction,
  setUserProfileAction,
  setBotAvatarsAction,
  setUserAvatarsAction,
  setUserLanguageAction,
  updateUserAvatarAction,
  updateBotAvatarAction,
  setUserNicknameAction,
  setSiteSettingsAction,
  setUserGroupsAction,
  emailNotVerifiedAction,
  setVerificationEmailAction,
  setVerificationEmailSentAction
};

export type AuthActionsType = InferActionsTypes<typeof authActions>
